import { LitElement, html, css } from "lit";
import { repeat } from "lit/directives/repeat.js";
import language from "#scripts/translation";

export class MyPageServicesList extends LitElement {
  static properties = {
    services: { attribute: false },
  };

  static styles = css`
    :host {
      width: 100%;
    }

    .material-icons-outlined,
    .material-symbols-outlined {
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 32px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
    }

    .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
    }

    .list__container {
      margin-inline: auto;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
    }
      
    .list__items {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      padding: 40px 30px;
      margin-right: 240px;
      background-color: #fff;
      border-radius: 6px;
      @media(max-width: 768px) {
        margin-right: 0px;
        margin-inline: 15px;
        padding: 20px;
      }
    }

    .filter {
      margin-bottom: 30px;
      /* display: flex; */
      display: none;
      border-radius: 4px;
    
      &:focus-within {
        outline: 2px solid #666;
        /* outline-offset: 3px; */
      }
      
      & input {
        /* background: var(--header__search__input_bg, #fff); */
        border: 1px solid #666;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        border-right: 0;
        padding: 12px 16px;
        width: 100%;
        /* max-width: 100vw; */
        font-size: 1rem;
        line-height: 22px;
      }

      & input:focus {
        outline: none;
      }

      & button {
        background-color: #fff;
        color: #1e1e1e;
        border: 1px solid #666;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        border-left: 0 solid transparent;
        padding: 12px;
      }

      & button:focus {
        outline: none;
        background-color: #efefef;
      }
    }

    .paging {
      display: flex;
      margin-top: 40px;
      align-items: center;

      & button {
        border: 1px solid #666;
        padding: 10px;
        line-height: 1rem;
        font-size: 38px;
        background-color: #fff;

        &:disabled {
          color: #D9D9D9;
        }
        &.back {
          border-radius: 4px 0px 0px 4px;
        }

        &.next {
          border-radius: 0px 4px 4px 0px;
          margin-left: -1px;
        }
      }

      & .pageinfo {
        /* align-items: center; */
        margin-left: 20px;
      }
    }
    /* @container (width < 1140px) {
      .menu__container {
        max-width: 1140px;
      }
    } */
  `;

  constructor() {
    super();
    this.services = getServices();
  }

  get _input () {
    if (!this.___input) {
      this.___input = this.renderRoot?.querySelector("input") ?? null;
    }
    return this.___input;
  }

  render () {
    const backDisabled = this.services.forespurtFra === 0;
    const nextDisabled = this.services.forespurtFra + this.services.forespurtAntall >= this.services.antallTreff;

    return html`
      <div class="list__container">       
        <div class="list__items">
          <div class='filter' role='search'>
            <input type='text' placeholder='${language("MYPAGE_SERVICES_SEARCH_PLACEHOLDER")}' area-label='${language("MYPAGE_SERVICES_SEARCH_PLACEHOLDER")}'>
            <button aria-label="${language("MYPAGE_SERVICES_SEARCH_LABEL")}" @click='${this._handleFilterClick}'>
              <span class="material-icons-outlined notranslate header__icon"></span>
            </button>
          </div>  
          ${repeat(
      this.services.treff,
      (service) => service.meldingId,
      (service, index) => html`<mypage-service-item .item=${service}></mypage-service-item>`,
    )}
          <slot></slot>
          <div class="paging">
            <button class="back" .disabled=${backDisabled} @click='${this._handleBackClick}'><span class="material-icons-outlined">navigate_before</span></button>
            <button class="next" .disabled=${nextDisabled} @click='${this._handleNextClick}'><span class="material-icons-outlined">navigate_next</span></button>
            <div class="pageinfo">${this.services.forespurtFra + 1}-${this.services.antallTreff < this.services.forespurtAntall ? this.services.antallTreff : this.services.forespurtAntall} ${language("MYPAGE_SERVICES_PAGING_LABEL")} ${this.services.antallTreff}</div>
          </div>
        </div>
      </div>`;
  }

  _handleFilterClick () {
    this.services = getServices2();
  }

  _handleBackClick () {
    console.log("Back clicked!");
    this.services = getServices();
  }

  _handleNextClick () {
    console.log("Next clicked!");
    this.services = getServices2();
  }
}

export class MyPageServiceItem extends LitElement {
  static properties = {
    item: { type: Object, reflect: true },
  };

  static styles = css`
    :host {
      display: contents;
      height: min-content;
    }

    .material-icons-outlined,
    .material-symbols-outlined {
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 32px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
    }

    .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
    }

    .serviceitem {
      flex: 1  1 48.5%;
      display: flex;
      border-bottom: 1px solid #ddd;
    }

    .wrapper {
      background: var(--minside__serviceitem_bg, #ffffff);
      /* border: 6px solid var(--minside__menu__item_bg, #ffffff); */
      border-radius: var(--minside__menu__item_border-radius, 6px);
      display: flex;
      width: -webkit-fill-available;
      margin-bottom: 0!important;
      padding: 0px;
      align-items: flex-start;
      gap: 20px;
    }
    
    .info {
      display: flex;
      flex-direction: column;
      width: -webkit-fill-available;
    }

    .icon {
      color: #707070;
      justify-content: center;
    }
    
    .title {
      font-size: 1.25rem;
      color: var(--black__text);
      font-weight: 600;
    }
    
    .text {
      font-size: 16px;
      color: #666;
    }

    .grow {
      flex-grow: 1;
    }

    .label {
      font-weight: var(--f-w-2);
      width: 150px;
    }

    .link {
      text-decoration: none;
      color: var(--minside__serviceitem_color,#333);
      display: flex;
      gap: 6px;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
    }

    .link:hover {
      /* text-decoration: underline; */
      color: var(--minside__serviceitem_color_hover,#333);
      background-color: var(--minside__serviceitem_bg_hover, var(--primary__color-200, #eee));
      & .title {
        text-decoration: underline;
        text-decoration-thickness: 2px;
      }
    }

    .spacer {
      height: 45px;
    }
  `;

  // constructor() {
  //   super();
  // }

  render () {
    const title = this.item?.meldingMetadata.tittel;
    const link = this.item?.meldingMetadata.lenke;
    const municName = this.item?.meldingMetadata.kommuneVisningsnavn;
    return html`
      <div class="serviceitem">
        <div class="wrapper">
          <div class="info">
            <a href="${link}" target="_blank" aria-label="${municName} (${language("NAV_OPEN_I_NEW")})" class="link">
              <div>
                <div class="text">${municName}</div>
                <div class="title">${title}</div>
              </div>
              <div class='icon'>
                <span class="material-icons-outlined">open_in_new</span>
              </div>
            </a>
          </div>
        </div>
      </div>`;
  }
}

customElements.define("mypage-services-list", MyPageServicesList);
customElements.define("mypage-service-item", MyPageServiceItem);

const getServices = () => {
  return JSON.parse(window.serverdata.configMeta.aim.mysite.services.links);
};
